import { useState, useEffect } from "react"
import { useRouter } from "next/router"
import { isEmptyObject } from "../../services/utils/isEmptyObject"
import { sorts } from "../../services/utils/sorts"
import windowService from "../../services/WindowService"
import { buildParams } from "../pages/CollectionPage/utils/buildParams"
import { callArtworksApi } from "../pages/CollectionPage/utils/callArtworksApi"
import { useInfinitePagination } from "./useInfinitePagination"
import {
  getQueryParams,
  setQueryParams,
} from "../pages/CollectionPage/utils/mapQueryParams"

const totalFilters = (search) => {
  return Object.keys(search)
    .map((key) => search[key])
    .filter((val) => {
      return Array.isArray(val) ? val.length > 0 : !!val
    }).length
}

export const useCollectionAction = ({
  catalogData,
  setCatalogData,
  gallery,
  filters,
  collection,
}) => {
  const router = useRouter()
  const [loading, setLoading] = useState(false)
  const [firstRender, setFirstRender] = useState(true)
  const [showFilters, setShowFilters] = useState(false)
  const [queryFilters, setQueryFilters] = useState(false)
  const _sorts = sorts.artworks
  const [sort, setSort] = useState("createddesc")
  const [search, setSearch] = useState({
    colors: [],
    collections: [],
    sizes: [],
    type: [],
    orientations: [],
    medium: [],
    material: [],
    minHeight: null,
    maxHeight: null,
    minWidth: null,
    maxWidth: null,
  })
  const [collapses, setCollapses] = useState({
    collections: true,
    sizes: true,
    type: true,
    orientations: true,
    medium: true,
    material: true,
    dimensions: true,
    colors: true,
  })

  const { setPage, setShouldCall } = useInfinitePagination(
    (page) => {
      let params = buildParams(search)
      return callArtworksApi({ ...params, page }, gallery, collection)
    },
    (response) =>
      setCatalogData({
        ...catalogData,
        data: [...catalogData.data, ...response.data],
      }),
  )

  useEffect(() => {
    if (queryFilters) {
      const params = buildParams(search, sort)
      if (!isEmptyObject(params)) {
        setLoading(true)
        callArtworksApi(params, gallery, collection).then((response) => {
          setCatalogData(response.data)
          setLoading(false)
        })
      } else if (!firstRender) {
        callCleanApi()
      }
    }
  }, [search, sort])

  useEffect(() => {
    mapQueryFilters()
    setFirstRender(false)
  }, [])

  const clearFilters = () => {
    const initSearch = {
      colors: [],
      collections: [],
      sizes: [],
      shapes: [],
      orientations: [],
      medium: [],
      material: [],
      minHeight: null,
      maxHeight: null,
      minWidth: null,
      maxWidth: null,
    }
    setSearch(initSearch)
    setQueryParams(initSearch, router, filters)
  }

  const callCleanApi = () => {
    setPage(1)
    setShouldCall(true)
    windowService.animatedScrollTop()
    setLoading(true)
    callArtworksApi(null, gallery, collection).then((response) => {
      setCatalogData(response.data)
      setLoading(false)
    })
  }

  const onClickString = (key, value) => {
    search[key] = value
    setSearch({ ...search })
    setQueryParams({ ...search }, router, filters)
  }

  const onClickArray = (key, value) => {
    const index = search[key].indexOf(value)

    if (index === -1) {
      search[key].push(value)
    } else {
      search[key].splice(index, 1)
    }

    setSearch({ ...search })
    setQueryParams({ ...search }, router, filters)
  }

  const onClickItem = (key, value) => {
    if (["minHeight", "maxHeight", "minWidth", "maxWidth"].includes(key)) {
      return onClickString(key, value)
    }

    return onClickArray(key, value)
  }

  const mapQueryFilters = () => {
    let filterParams = getQueryParams(
      router.query,
      {
        ...search,
      },
      filters,
    )
    setSearch(filterParams)
    setQueryFilters(true)
  }

  const toggleExpand = (key) => {
    const _collapses = collapses
    _collapses[key] = !_collapses[key]
    setCollapses({ ..._collapses })
  }

  return {
    loading,
    setLoading,
    search,
    setSearch,
    collapses,
    setCollapses,
    clearFilters,
    onClickItem,
    toggleExpand,
    totalFilters: totalFilters(search),
    showFilters,
    setShowFilters,
    sort,
    setSort,
    sorts: _sorts,
  }
}
